/**
 * Validate money in US and other patterns without the prefix or sufix.
 * Only validates numbers with commas and dots.
 * Ex: 100,00  // is valid
 * Ex: 100.00  // is valid
 * Ex: 100a00  // is invalid
 * Ex: 1,000.0 // is valid
 * Ex: 1.000,0 // is valid
 *
 * @param {String} number
 * @return Boolean
 */
function isMoney(number, canBeNegative = false) {
  return new RegExp('^' + (canBeNegative ? '\-?' : '') + '[0-9]{1,3}(\,?[0-9]{3})*(\.[0-9]+)?$').test(number)
    || new RegExp('^' + (canBeNegative ? '\-?' : '') + '[0-9]{1,3}(\.?[0-9]{3})*(,[0-9]+)?$').test(number);
}

module.exports = isMoney;
